import { createApp, h } from "vue";
import { createInertiaApp, Link, Head } from "@inertiajs/vue3";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "../css/app.css";
// import { ZiggyVue } from "ziggy";
// import { Ziggy } from "./ziggy";
import AlertBar from "../js/Components/Modules/AlertBar.vue";
import PageIntro from "../js/Components/Page-Components/PageIntro.vue";
import Layout from "../js/Layouts/Main.vue";

const pages = import.meta.glob("./Pages/**/*.vue");

createInertiaApp({
  resolve: async (name) => (await pages[`./Pages/${name}.vue`]()).default,
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) });

    const toastOptions = {
      position: "top-center",
      timeout: 10000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: false,
      showCloseButtonOnHover: false,
      closeButton: "button",
      icon: true,
      rtl: false,
      transition: "fade",
      toastClassName: "toastification",
    };

    app.provide("hostname", window.location.origin);

    app
      .use(plugin)
      // .use(ZiggyVue, Ziggy)
      // .use(Ziggy)
      .use(Toast, toastOptions)
      .component("AlertBar", AlertBar)
      .component("PageIntro", PageIntro)
      .component("Layout", Layout)
      .component("Link", Link)
      .component("Head", Head)
      .mixin({ methods: { route } })
      .mount(el);
  },
});
